import React from 'react'
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section className='hero-section'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                    <div className='hero-content mb-5 text-center'>
                        <h1 className='text-center mb-4 text-uppercase'>
                            FTL Ambassador Login
                        </h1>
                        <p className='mb-3'>The Financial and Tax Literacy Ambassador Program is designed to honor individuals who have made significant contributions to enhancing financial and tax literacy in India. Participants will register through the Vittya Gyan Mela website/app, providing detailed information about their efforts and achievements. The program will feature two categories: Chartered Accountants and Students, with each branch recognizing top ambassadors in both categories.</p>
                        <Link to="/ambassador/registration" className='bg-primary d-inline-flex text-white py-3 px-5 rounded-5'>Be an Ambassador</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Hero
